import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { useMutation } from "react-query";
import { ResultResubmission } from "../shared/interfaces/Result";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";

export function useResultResubmission(callbacks?: QueryCallbacks<void>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["resubmitResult"],
    async (resultResubmission: ResultResubmission) => apiContext.resultsApis.resubmitResult(resultResubmission),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
